/**
 * Owner: Haselton Baker Risk Group, LLC
 * Copyright All Rights Reserved
 */
// @flow
import type { Element } from 'react';

import React from 'react';
import { Form } from 'reactstrap';
import {
  HAZARD_EDITION,
  SITE_CLASS,
} from '@hbrisk/sp3-risk-model-support/models/app/attributes/names/index.js';
import BackButton from '#components/pages/Models/Model/sections/support/buttons/BackButton.jsx';
import NextButton from '#components/pages/Models/Model/sections/support/buttons/NextButton.jsx';
import {
  Field,
  FormGroup,
  Fieldset,
  FormGroupCol as Col,
} from '#components/pages/Models/Model/support/form/index.js';

type Props = {|
  fieldsByName: Object,
  form: string,
  heading: string,
  onBack: Function,
  onNext: Function,
|};

const GroundMotionAndSoilInfoSection = ({
  fieldsByName,
  form,
  heading,
  onBack,
  onNext,
}: Props): Element<'div'> => (
  <div>
    <h2>{heading}</h2>
    <Form noValidate>
      <Fieldset>
        <legend>Ground Motion and Soil Information</legend>
        <FormGroup form={form} fields={[HAZARD_EDITION]} row>
          <Col lg="6">
            <Field field={fieldsByName[HAZARD_EDITION]} />
          </Col>
        </FormGroup>
        <FormGroup form={form} fields={[SITE_CLASS]} row>
          <Col lg="6">
            <Field field={fieldsByName[SITE_CLASS]} />
          </Col>
        </FormGroup>
      </Fieldset>
      <BackButton onClick={onBack} />
      <NextButton onClick={onNext} />
    </Form>
  </div>
);

export default GroundMotionAndSoilInfoSection;
